jQuery(function ($) {
  var mealType = '';
  var WorkoutMealScript = {
    products: {
      filter: function () {
        $(".section-collections-products, .wm-mobile-filter-popop").on(
          "click",
          ".wm-products-filter a",
          function (e) {
            e.preventDefault();

            thiObj = $(this);

            let selectorString = '.section-collections-products .product-list > div > div';
            let calorie = [];
            let protein = [];
            let allergen = [];
            let goal = [];

            // Hide load more
            $('.wm-page-loadmore').addClass('hidden');

            // Filter for Meal Type
            if (
              thiObj.parents(".wm-products-filter").data("tag-type") == "tags_with_wm_fil"
            ) {

              if (!thiObj.parent().hasClass("active")) {
                thiObj
                .parents(".wm-products-filter")
                .find(">li")
                .removeClass("active");
                thiObj.parent().addClass("active");
                mealType = $(this).data('tag');

              } else {
                thiObj.parent().removeClass("active");
                mealType = '';
              }
            }

            // Filter for Calorie
            if (
              thiObj.parents(".wm-products-filter").data("tag-type") == "tags_with_wm_cal"
            ) {

              if (!thiObj.parent().hasClass("active")) {
                thiObj
                .parents(".wm-products-filter")
                .find(">li")
                .removeClass("active");
                thiObj.parent().addClass("active");

              } else {
                thiObj.parent().removeClass("active");
              }
            }

            // Filter for Protein
            if (
              thiObj.parents(".wm-products-filter").data("tag-type") ==
              "tags_with_wm_pt"
            ) {
              
              if (!thiObj.parent().hasClass("active")) {
                thiObj.parent().addClass("active");
              } else {
                thiObj.parent().removeClass("active");
              }
            }

            // Filter for Goal
            if (
              thiObj.parents(".wm-products-filter").data("tag-type") ==
              "tags_with_goal"
            ) {
              
              if (!thiObj.parent().hasClass("active")) {
                thiObj.parent().addClass("active");
              } else {
                thiObj.parent().removeClass("active");
              }
            }

            // Filter for Allergens
            if (
                thiObj.parents(".wm-products-filter").data("tag-type") ==
                "tags_with_kc_al"
              ) {
                
                if (!thiObj.parent().hasClass("active")) {
                  thiObj.parent().addClass("active");
                } else {
                  thiObj.parent().removeClass("active");
                }
              }

            $('.wm-products-filter[data-tag-type="tags_with_wm_pt"]').find(">li.active a").each(function() {
                protein.push($(this).data('tag'));
            });

            $('.wm-products-filter[data-tag-type="tags_with_goal"]').find(">li.active a").each(function() {
              //if (goal[0]) {
                //goal[0].append($(this).data('tag'));
              //} else {
                goal.push($(this).data('tag'));
              //}
          });

            $('.wm-products-filter[data-tag-type="tags_with_kc_al"]').find(">li.active a").each(function() {
                allergen.push($(this).data('tag'));
            });

            $('.wm-products-filter[data-tag-type="tags_with_wm_cal"]').find(">li.active a").each(function() {
              calorie.push($(this).data('tag'));
            });

            $(".section-collections-products .product-list > div > div.product-card-wrapper").addClass('hidden');

            count = 0;

            $(selectorString).each(function(){
                thisObj = $(this);
                let state1 = 0, state2 = 0, state3 = 0, state4 = 0, state5 = 0;

                if(mealType != '') {
                    if(thisObj.find('.wm-product-tags:contains("' + mealType + '")').length != 0) {
                        state1 = 1;
                    }
                }

                if(protein.length !== 0) {
                  let tempSelector = '';
                  protein.forEach(paa => {
                      tempSelector += '.wm-product-tags:contains("' + paa + '"),'

                      if(thisObj.find(tempSelector.replace(/,\s*$/, "")).length != 0) {
                        state2 = 1;
                      }
                      
                  });
                }

                if(goal.length !== 0) {
                  //console.log("goal", goal);
                  let tempSelector = '', tempState5 = 0 ;
                  let goals = '';
                  goal.forEach( gls => {
                    if (goals !== '') {
                      goals += ',' + gls
                    } else {
                      goals += gls
                    }
                  });

                  goals = goals.split(',');
                  goals = [...new Set(goals)];

                  goals.forEach(g => {
                    tempSelector += '.wm-product-tags:contains("' + g + '"),'

                    if(thisObj.find(tempSelector.replace(/,\s*$/, "")).length != 0) {
                      tempState5 = tempState5 + 1;
                      state5 = 1;
                    }
                    if(goal.length == tempState5) {
                      state5 = 1;
                    }
                    if (g === 'show all') {
                      state5 = 1;
                      goal.length = 0;
                    }
                  });
                }

                if(allergen.length !== 0) {
                  let tempSelector = '', tempState3 = 0;
                  allergen.forEach(alg => {
                    tempSelector += '.allergens:contains("' + alg + '"),'

                    if(thisObj.find(tempSelector.replace(/,\s*$/, "")).length == 0) {
                      tempState3 = tempState3 + 1;
                    }
                  });

                  if(allergen.length == tempState3) {
                    state3 = 1;
                  }
                  //console.log("allergen", allergen);
                }

                if(calorie.length !== 0) {
                  let tempSelector = '';
                  calorie.forEach(cal => {
                      tempSelector += '.wm-product-tags:contains("' + cal + '"),'

                      if(thisObj.find(tempSelector.replace(/,\s*$/, "")).length != 0) {
                        state4 = 1;
                      }
                      
                  });
                }
                

                if(mealType != '' && protein.length !== 0 && goal.length !== 0 && allergen.length !== 0 && calorie.length !== 0) {
                    if(state1 == 1 && state2 == 1 && state3 == 1 && state4 == 1 && state5 == 1) {
                      thisObj.removeClass('hidden');
                    }
                } else if(mealType != '' && protein.length !== 0) {
                    if(state1 == 1 && state2 == 1) {
                      thisObj.removeClass('hidden');
                    }
                } else if(protein.length !== 0 && allergen.length !== 0) {
                    if(state2 == 1 && state3 == 1) {
                      thisObj.removeClass('hidden');
                    }
                } else if(mealType != '' && goal.length !== 0) {
                    if(state1 == 1 && state5 == 1) {
                      thisObj.removeClass('hidden');
                  }
                } else if(mealType != '' && allergen.length !== 0) {
                    if(state1 == 1 && state3 == 1) {
                      thisObj.removeClass('hidden');
                    }
                } else if(mealType != '' && calorie.length !== 0) {
                    if(state1 == 1 && state4 == 1) {
                      thisObj.removeClass('hidden');
                    }
                } else if(calorie.length !== 0 && allergen.length !== 0) {
                    if(state3 == 1 && state4 == 1) {
                      thisObj.removeClass('hidden');
                    }
                } else if(protein.length !== 0 && calorie.length !== 0) {
                    if(state2 == 1 && state4 == 1) {
                      thisObj.removeClass('hidden');
                    }
                } else if(goal.length !== 0 && allergen.length !== 0) {
                  if(state5 == 1 && state3 == 1) {
                    thisObj.removeClass('hidden');
                  }

                } else if(goal.length !== 0 && protein.length !== 0) {
                  if(state5 == 1 && state2 == 1) {
                    thisObj.removeClass('hidden');
                  }

                } else if(goal.length !== 0 && calorie.length !== 0) {
                  if(state5 == 1 && state1 == 1) {
                    thisObj.removeClass('hidden');
                  }
                
                } else if(mealType != '') {
                    if(state1 == 1) {
                      thisObj.removeClass('hidden');
                    }
                } else if(protein.length !== 0) {
                    if(state2 == 1) {
                      thisObj.removeClass('hidden');
                    }
                } else if(goal.length !== 0) {
                    if(state5 == 1) {
                      thisObj.removeClass('hidden');
                    }
                } else if(allergen.length !== 0) {
                    if(state3 == 1) {
                      thisObj.removeClass('hidden');
                    }
                } else if(calorie.length !== 0) {
                    if(state4 == 1) {
                      thisObj.removeClass('hidden');
                    }
                } else if(mealType == '' && protein.length === 0 && allergen.length === 0 && calorie.length === 0 && goal.length === 0) {
                  thisObj.removeClass('hidden');
                }
            });
            
            $('.product-list-meal-type').removeClass('hidden');

            // Hide headers
           
            if(!$('.wm-new-meals-group').is(":visible")) {
              $('.plmt-new-meals').addClass('hidden');
            }

            if(!$('.wm-breakfast-group').is(":visible")) {
              $('.plmt-breakfast').addClass('hidden');
            }

            if(!$('.wm-lunch-group').is(":visible")) {
              $('.plmt-lunch').addClass('hidden');
            }

            if(!$('.wm-salad-group').is(":visible")) {
              $('.plmt-salad').addClass('hidden');
            }

            if(!$('.wm-low-calorie-group').is(":visible")) {
              $('.plmt-low-calorie').addClass('hidden');
            }

            if(!$('.wm-high-protein-group').is(":visible")) {
              $('.plmt-high-protein').addClass('hidden');
            }

            if(!$('.wm-every-day-group').is(":visible")) {
              $('.plmt-high-everday').addClass('hidden');
            }

            if(!$('.wm-Snack-group').is(":visible")) {
              $('.plmt-Snack').addClass('hidden');
            }
           

            $('.plml-count').text($('.wm-scp-wrapper .product-list > div > div:visible').length + ' items');
      
          }
        );
      },

      sorting: function () {
          $('.wm-cb-filter-sort-popup input[name=sorty_by], .wm-mfp-sort-radio input[name=sorty_by]').change(function() {
              $('.wm-cb-filter-sort .wm-cb-filter-sort-selected, .plml-sort').text($(this).val());
             
              let productListObj = $(".section-collections-products .product-list > div > div.product-card-wrapper");

              $(".section-collections-products .product-list > div > div.product-card-wrapper:not(.product-list--section-banner)").removeAttr('style');

              if($(this).val() == 'Alphabetical (A-Z)') {
                productListObj.sort(function (a, b) {
                    return ($(a).attr('data-title') < $(b).attr('data-title')) ? -1 : ($(a).attr('data-title') > $(b).attr('data-title')) ? 1 : 0;
                })
              } else if($(this).val() == 'Calories: Low to High') {
                productListObj.sort(function (a, b) {
                    return $(a).data('calories')-$(b).data("calories")
                })
              } else if($(this).val() == 'Calories: High to Low') {
                productListObj.sort(function (a, b) {
                    return $(b).data('calories')-$(a).data("calories")
                })
              } else if($(this).val() == 'Most Recent') {          
                productListObj.sort(function (a, b) {
                  return $(b).data('created')-$(a).data("created")
                })
              } else if($(this).val() == 'Most Popular') {          
                productListObj.sort(function (a, b) {
                  // return $(b).data('popularity')-$(a).data("popularity") - tasks 121
                  return $(a).attr("data-recommended")-$(b).attr("data-recommended")
                })
              } else if($(this).val() == 'Most Recommended') {          
                productListObj.sort(function (a, b) {
                  return $(a).attr('data-recommended')-$(b).attr("data-recommended")
                })
              }

             // $(".section-collections-products .product-list").html(productListObj);
             $('.section-collections-products .product-list > div > div.product-card-wrapper:not(.product-list--section-banner)').remove();
             // $('.section-collections-products .product-list > div > div.product-card-wrapper').remove();

              let indxOrder = [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1];
              productListObj.each(function() {

                if($(this).hasClass('wm-menu-new-meals-group')) {
                  $('.section-collections-products .product-list .product-list--section_menu-new-meals').append($(this).attr('style', 'order:' + indxOrder[0]))
                  indxOrder[0]++;
                } else if($(this).hasClass('wm-low-calorie-group')) {
                  $('.section-collections-products .product-list .product-list--section_low-calorie').append($(this).attr('style', 'order:' + indxOrder[1]))
                  indxOrder[1]++;
                } else if($(this).hasClass('wm-high-protein-group')) {
                  $('.section-collections-products .product-list .product-list--section_high-protein').append($(this).attr('style', 'order:' + indxOrder[2]))
                  indxOrder[2]++;
                } else if($(this).hasClass('wm-everyday-group')) {
                  $('.section-collections-products .product-list .product-list--section_everyday').append($(this).attr('style', 'order:' + indxOrder[3]))
                  indxOrder[3]++;
                } else if($(this).hasClass('wm-lunch-group')) {
                  $('.section-collections-products .product-list .product-list--section_lunch').append($(this).attr('style', 'order:' + indxOrder[4]))
                  indxOrder[4]++;
                } else if($(this).hasClass('wm-salad-group')) {
                  $('.section-collections-products .product-list .product-list--section_salad').append($(this).attr('style', 'order:' + indxOrder[5]))
                  indxOrder[5]++;
                } else if($(this).hasClass('wm-breakfast-group')) {
                  $('.section-collections-products .product-list .product-list--section_breakfast').append($(this).attr('style', 'order:' + indxOrder[6]))
                  indxOrder[6]++;
                } else if($(this).hasClass('wm-snacks-group')) { //wm-snack-alt-group
                  $('.section-collections-products .product-list .product-list--section_snacks').append($(this).attr('style', 'order:' + indxOrder[7]))
                  indxOrder[7]++;
                } else if($(this).hasClass('wm-air-fry-group')) {
                  $('.section-collections-products .product-list .product-list--section_air-fry').append($(this).attr('style', 'order:' + indxOrder[8]))
                  indxOrder[8]++;
                } else if($(this).hasClass('wm-menu-snacks-group')) {
                  $('.section-collections-products .product-list .product-list--section_menu-snacks').append($(this).attr('style', 'order:' + indxOrder[9]))
                  indxOrder[9]++;
                } else if($(this).hasClass('wm-menu-soup-group')) {
                  $('.section-collections-products .product-list .product-list--section_menu-soup').append($(this).attr('style', 'order:' + indxOrder[10]))
                  indxOrder[10]++;
                } else if($(this).hasClass('wm-all-day-breakfast-group')) {
                  $('.section-collections-products .product-list .product-list--section_all-day-breakfast').append($(this).attr('style', 'order:' + indxOrder[11]))
                  indxOrder[11]++;
                } else if($(this).hasClass('wm-vegan-group')) {
                  $('.section-collections-products .product-list .product-list--section_vegan').append($(this).attr('style', 'order:' + indxOrder[12]))
                  indxOrder[12]++;
                } else if($(this).hasClass('wm-glp-1-group')) {
                  $('.section-collections-products .product-list .product-list--section_glp-1').append($(this).attr('style', 'order:' + indxOrder[13]))
                  indxOrder[13]++;
                } else if($(this).hasClass('wm-af-group')) {
                  $('.section-collections-products .product-list .product-list--section_af').append($(this).attr('style', 'order:' + indxOrder[13]))
                  indxOrder[13]++;
                }


              });

              $('.plml-count').text($('.wm-scp-wrapper .product-list > div > div:visible').length + ' items');
          });

          // On Load default
          $(".wm-radio-default").prop("checked", true).change();
          $('.plml-count').text($('.wm-scp-wrapper .product-list > div > div:visible').length + ' items');
         
      },

      loadMore: function () {
        let disp = 30;
        let totalProduct = $(".section-collections-products").find(
          ".product-list > div > div"
        ).length;

        $(".section-collections-products").find(".wm-page-loadmore a").click(function () {
            disp = disp + 30;
          
            $(".section-collections-products")
              .find(".product-list > div > div:lt(" + disp + ")")
              .removeClass('hidden');

            if (disp >= totalProduct) {
              $(this).parent().addClass('hidden');
            }
            return false;
          });
      },

      popup: function () {

        // More Filter
        $('.wm-more-filters-wrapper .wm-more-filters').click(function() {
            if(!$(this).parent().find('.wm-more-filters-popup').hasClass('wm-popup-visible')) {
                $(this).parent().find('.wm-more-filters-popup').addClass('wm-popup-visible').show();
            } else {
                $(this).parent().find('.wm-more-filters-popup').removeClass('wm-popup-visible').hide();
            }
        });

        // Mobile Menu More Filter
        $('.wm-more-filters-mobile').on("click", function(evt) {
          //console.log("evt", evt);
          $('.wm-mobile-filter-popop').show();
        });
        $('.wm-mfp-close').click(function() {
          $('.wm-mobile-filter-popop').hide();
        });
        $('.wm-mfp-cear').click(function() {
          $('.mfp-accordion-filter > li').removeClass('active');
          $('.section-collections-products .product-list > div > div').removeClass('hidden');
          $('.wm-mfp-sort-radio input:first').prop('checked', true).change();
          $('.plml-count').text($('.wm-scp-wrapper .product-list > div > div:visible').length + ' items');
        });

        // Sorting
        $('.wm-cb-filter-sort > span').click(function() {
            if(!$(this).parent().find('.wm-cb-filter-sort-popup').hasClass('wm-popup-visible')) {
                $(this).parent().find('.wm-cb-filter-sort-popup').addClass('wm-popup-visible').show();
            } else {
                $(this).parent().find('.wm-cb-filter-sort-popup').removeClass('wm-popup-visible').hide();
            }
        });

        $('.wm-allergen-close').click(function() {
          $(this).parents('.wm-more-filters-popup').removeClass('wm-popup-visible').hide();
        });

        $('.wm-sort-close').click(function() {
          $(this).parents('.wm-cb-filter-sort-popup').removeClass('wm-popup-visible').hide();
        });
      },

      mobileMenu: function() {
        // $('.wm-more-filters-mobile').click(function(evt) {
        //   console.log("evt", evt);
        //   $('.wm-mobile-filter-popop').removeClass('hidden');
        // });
      },
      
      collectionDefaultOrder: function () {
        $('.product-list-meal-type').each(function() {
          if($(this).hasClass('plmt-end')) {
            return;
          }

          let collectionOrder = $(this).attr('data-collection-order').split(',');
          let mealTypeClass = $(this).attr('data-mealtype-class');

          // if(mealTypeClass == '.wm-Snack-group') {
          //   mealTypeClass == '.wm-snack-alt-group';
          // }

          collectionOrder.forEach(function(v, i) {

            $(mealTypeClass).each(function() {
              if($(this).attr('data-id') == v) {
                $(this).attr('data-recommended', i)
              }
            });

          });
        })
      },

      init: function () {
        if ($(".section-collections-products").length == 0) {
          return;
        }

        this.filter();
        this.loadMore();
        this.popup();
        this.collectionDefaultOrder();
        this.sorting();
        this.mobileMenu();
      },
    },

    makeYourPlan: {
      dailyTotal: function (){
        let totalMenuPrice = 0;
        $('.section-makeyourplan .wm-myp-menu').not('.wm-remove-from-plan').each(function() {
            let thisMenuObj = $(this);
            let price = 0, protein = 0, carbohydrate = 0, fattotal = 0;

            thisMenuObj.find('.mw-myp-product-item').each(function(){
              thisItemObj = $(this);
              price += (parseFloat(thisItemObj.attr('data-price')) / 100);
              protein += parseFloat(thisItemObj.attr('data-protein'));
              carbohydrate += parseFloat(thisItemObj.attr('data-carbohydrate'));
              fattotal += parseFloat(thisItemObj.attr('data-fattotal'));
            });
         
            totalMenuPrice += price;

            thisMenuObj.find('.wm-myp-total-protein > span').text(protein.toFixed(0));
            thisMenuObj.find('.wm-myp-total-carbohydrate > span').text(carbohydrate.toFixed(0));
            thisMenuObj.find('.wm-myp-total-fattotal > span').text(fattotal.toFixed(0));

          });

          $('.section-makeyourplan').find('.wm-myp-total-price').text(new Intl.NumberFormat('en-US', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2}).format(totalMenuPrice));
      },

      numberOfDays: function () {
        $('.section-makeyourplan .wm-day-plan > span').click(function() {
          let thisObj = $(this);
          let elementSelector = '.section-makeyourplan .wm-myp-menu:eq(5), .section-makeyourplan .wm-myp-menu:eq(6)';
          if(!thisObj.hasClass('wm-active')) {
            $('.section-makeyourplan .wm-day-plan > span').removeClass('wm-active');
            thisObj.addClass('wm-active');
          } else {
            thisObj.removeClass('wm-active');
          }

          if(thisObj.data('days') == '5') {
            $(elementSelector).addClass('wm-remove-from-plan');
          } else {
            $(elementSelector).removeClass('wm-remove-from-plan');
          }

          WorkoutMealScript.makeYourPlan.dailyTotal();

        });
      },


      addToCart: function() {
        thisObj = this;

        $('.wm-confirm-plan').click(function() {
          let cartItems = [];
          let cartNotes = '';

          $('.section-makeyourplan .wm-myp-menu').not('.wm-remove-from-plan').each(function() {
            let thisMenuObj = $(this);

            cartNotes += "\r\n --> Plan " + thisMenuObj.attr('data-day') + " <-- \r\n ";
            
            thisMenuObj.find('.mw-myp-product-item').each(function(){
              thisItemObj = $(this);

              if(thisItemObj.attr('data-variant-id') != 0) {

                let productItem  = {
                  'id': thisItemObj.attr('data-variant-id'),
                  'quantity': 1
                };

                let existingProduct = cartItems.findIndex(ci => ci.id == productItem.id);
                
                if(existingProduct > 0) {
                  cartItems[existingProduct].quantity = cartItems[existingProduct].quantity + 1;
                } else {
                  cartItems.push(productItem);
                }

                cartNotes += thisItemObj.attr('data-title') + "\r\n ";
              }
            });
          });

  
          // Add to Cart
          $.ajax({
            method: "POST",
            url: window.Shopify.routes.root + 'cart/add.js',
            dataType: 'json',
            data: { items: cartItems }
          }).done(function( response ) {
            thisObj.addCartNote(cartNotes);
            setTimeout(cartIcon, 50);
          });
        });
        
      },

      addCartNote: function (cartNotes) {
        $.ajax({
          method: "POST",
          url: window.Shopify.routes.root + 'cart/update.js',
          data: { note: cartNotes}
        }).done(function( response ) {
          $('.header-cart.js-drawer-open-button-right').trigger("click");
        });
      },

      swap: function () {
        let thisObj = this;
        let currentlySelectedMeal = '';
        let type = '';

        $('.wm-menu-daily-open-swap-popup').click(function() {
          let thisDomParentObj = $(this).parents('.mw-myp-product-item');
          let popupcurrentProdPreview = $('.wm-myp-magnific-popup-swap .wm-current-product-preview');
          popupcurrentProdPreview.removeClass('hidden');

          currentlySelectedMeal = thisDomParentObj;
          type = 'swap';

          if(thisDomParentObj.attr('data-meal-type') == 'bld') {
            $('.wm-ps-ds').addClass('wm-hide');
            $('.wm-ps-bld').removeClass('wm-hide');
            $('.wm-ps-ea').addClass('wm-hide');
          } else if(thisDomParentObj.attr('data-meal-type') == 'ds') {
            $('.wm-ps-ds').removeClass('wm-hide');;
            $('.wm-ps-bld').addClass('wm-hide');
            $('.wm-ps-ea').addClass('wm-hide');
          }

          popupcurrentProdPreview.find('.wm-current-product-img img').attr('src', thisDomParentObj.attr('data-image'));
          popupcurrentProdPreview.find('.wm-current-product-title').text( thisDomParentObj.attr('data-title'))
          
          $.magnificPopup.open({items: {src: '.wm-magnific-popup'},type: 'inline'}, 0);
        });

        $('.wm-menu-daily-add-extra').click(function() {
          let thisDomParentObj = $(this).parents('.mw-myp-product-item');
          $('.wm-myp-magnific-popup-swap .wm-current-product-preview').addClass('hidden');

          currentlySelectedMeal = thisDomParentObj;
          type = 'add';

          $('.wm-ps-ds').addClass('wm-hide');
          $('.wm-ps-bld').addClass('wm-hide');
          $('.wm-ps-ea').removeClass('wm-hide');

          $.magnificPopup.open({items: {src: '.wm-magnific-popup'},type: 'inline'}, 0);
        });

        $('.wm-menu-daily-products-extras .wm-x').click(function() {
          let thisObj = $(this).parents('.wm-menu-daily-products-extras');
          thisObj.addClass('wm-hide-product-item-field');

          thisObj.attr('data-price', 0);
          thisObj.attr('data-protein', 0);
          thisObj.attr('data-carbohydrate', 0);
          thisObj.attr('data-fattotal', 0);
          thisObj.attr('data-calories', 0);
          thisObj.attr('data-id', 0);
          thisObj.attr('data-variant-id', 0);
          thisObj.attr('data-image', '');
          thisObj.attr('data-title', 0);

          thisObj.find('.wm-menu-daily-image img').attr('src', thisObj.find('.wm-menu-daily-image img').attr('data-default-src'))
          WorkoutMealScript.makeYourPlan.dailyTotal();

          thisObj.removeClass('contained');

          $(thisObj?.find('.wm-menu-daily-swap.wm-menu-daily-add-extra')?.[0]?.children?.[0])?.text("Add");
        })


        $('.wm-menu-daily-select-product').click(function() {

          let thisDomParentObj = $(this).parents('.mw-myp-product-item');

          thisObj.processSwap(thisDomParentObj, currentlySelectedMeal);

           if(type == 'add') {
             currentlySelectedMeal.removeClass('wm-hide-product-item-field');
           }

          WorkoutMealScript.makeYourPlan.dailyTotal();

          const currentlySelectedMealCard = currentlySelectedMeal?.[0];

          const cSMC = $(currentlySelectedMealCard);

          if (cSMC.hasClass('breakfast')) {
            cSMC.removeClass('wm-menu-daily-products-extras');
            cSMC.removeClass('wm-hide-product-item-field');
          }

          cSMC.addClass('contained');

          const closeBtn = currentlySelectedMealCard?.children?.[currentlySelectedMealCard?.children.length - 1];

          if ($(closeBtn?.children?.[0]).text() == 'Add') {
            $(closeBtn?.children?.[0])?.text('Swap');
          }

          thisDomParentObj?.addClass('contained');

          $.magnificPopup.close();
        });

        
      },


      processSwap: function (thisDomParentObj, currentlySelectedMeal) {
        currentlySelectedMeal.attr('data-price', thisDomParentObj.data('price'));
          currentlySelectedMeal.attr('data-protein', thisDomParentObj.data('protein'));
          currentlySelectedMeal.attr('data-carbohydrate', thisDomParentObj.data('carbohydrate'));
          currentlySelectedMeal.attr('data-fattotal', thisDomParentObj.data('fattotal'));
          currentlySelectedMeal.attr('data-calories', thisDomParentObj.data('calories'));
          currentlySelectedMeal.attr('data-id', thisDomParentObj.data('id'));
          currentlySelectedMeal.attr('data-variant-id', thisDomParentObj.data('variant-id'));
          currentlySelectedMeal.attr('data-image', thisDomParentObj.data('image'));
          currentlySelectedMeal.attr('data-title', thisDomParentObj.data('title'));

          currentlySelectedMeal.find('.wm-menu-daily-image img').attr('src', thisDomParentObj.data('image'));
          currentlySelectedMeal.find('.myp-product-title').text(thisDomParentObj.data('title'));
          currentlySelectedMeal.find('.myp-product-protein').text(thisDomParentObj.data('protein') + 'G PROTEINS');
          currentlySelectedMeal.find('.myp-product-carbohydrate').text(thisDomParentObj.data('carbohydrate') + 'G CARBS');
          currentlySelectedMeal.find('.myp-product-fattotal').text(thisDomParentObj.data('fattotal') + 'G FATS');
          currentlySelectedMeal.find('.myp-product-calories').text(thisDomParentObj.data('calories') + ' CALORIES');
      },

      init: function () {
        if ($(".section-makeyourplan").length == 0) {
          return;
        }
  
        this.dailyTotal();
        this.numberOfDays();
        this.addToCart();
        this.swap();
        // Reused from Products
        WorkoutMealScript.products.popup();

      }
    },

    tweaks: {
      productAddToCart: function () {
        $('.product-buybutton-via-quantity').click(function(){
          $(this).find('.pbvq-preview-btn').addClass('hidden');
          $(this).find('.pbvq-preview-atc').addClass('wm-visible');
        });

        $('.pbvq-product-add').click(function(){
          let quantity = $('.pbvq-product-count').text();
          let varianId = $(this).parents('.product-buybutton-via-quantity').attr('data-variant-id');
          quantity = parseInt(quantity) + 1;

          $('.pbvq-product-count').text(quantity);
          addProduct(varianId);
        });

        $('.pbvq-product-remove').click(function(){
          let quantity = $('.pbvq-product-count').text();
          let varianId = $(this).parents('.product-buybutton-via-quantity').attr('data-variant-id');

          quantity = parseInt(quantity) - 1;

          if(quantity <= 0) {
            quantity = 0;
          }

          let params = {
              quantity: quantity,
              id: varianId
          };
    
        removeProductCart(params);
          $('.pbvq-product-count').text(quantity);
        });
      },

      slider: function () {
        
        if ( window.matchMedia('screen and (max-width: 992px)').matches ) {

          if (window.location.href.indexOf('apps/kitchen-centre/meals') < 0) {

            if ( $.isFunction($.fn.flickity) ) {
              $('.wm-intro .wm-intro__columns').flickity({
                // options
                cellAlign: 'left',
                contain: true,
                prevNextButtons: false,
              });

              $('.wm-featured .wm-featured__list').flickity({
                // options
                cellAlign: 'center',
                groupCells: 3,
                contain: true,
                prevNextButtons: false,
                pageDots: false
              });
            }
          }
           
        } 
      },

      subscription: function() {

        let key_kitchen = window.theme.kitchenCentreKey;
        $.getJSON('/apps/' + key_kitchen + '/getMealsFilter', function (data) {
            if (data) {
                productPopUp(data.products);
                slate.subscriptions.changeMealsPage(data.products, key_kitchen);
                theme.mealPackProducts.mealPackAddToCartProducts();
            }
        });

        $('.pop-up-change-meal .close-pop-up-change-meal').click(function () {
            $('.pop-up-change-meal').addClass('hide').removeClass('change-meal new-meal special-meal').attr('data-change-price', '');
            $('body').removeClass('active-pop-up');
            $('.collection-meals-block').empty();
        });

        if ( window.matchMedia('screen and (max-width: 480px)').matches ) {
          $('.row-subscription-total > td:first-child').attr('colspan', 2);
        }

      },
    

      init: function() {
        this.productAddToCart();
        this.slider();
        this.subscription();
      }
    }

  };

  const WorkoutMealPopupAddonScript = {
    events: () => {
      $('body').on('click', (e) => {
        if (e.target === $('body')?.[0] && $('body').hasClass('active-pop-up')) {
          closeCartDrawer();
        }
      });
    },

    init: (e) => {
      const $this = WorkoutMealPopupAddonScript;
      $this.events();
    }
  };

  $(document).ready(function () {
    WorkoutMealScript.products.init();
    WorkoutMealScript.makeYourPlan.init();
    WorkoutMealScript.tweaks.init();
    WorkoutMealPopupAddonScript.init();
  });
});
